import React, { Children, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { hasSwipedLeft, hasSwipedRight } from '../../helpers/swipe';

import './mrx-carousel.scss';

const Carousel = ({ children }) => {
  const [currentOffset, setCurrentOffset] = useState(0);
  const touchDownPosition = useRef({ x: 0, y: 0 });
  return (
    <div className="sm-mrx-carousel__wrapper">
      <div
        className="sm-mrx-carousel"
        onTouchStart={e => {
          touchDownPosition.current = {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY,
          };
        }}
        onTouchEnd={e => {
          const pos = {
            x: e.changedTouches[0].clientX,
            y: e.changedTouches[0].clientY,
          };
          if (hasSwipedLeft(touchDownPosition.current, pos) && currentOffset < children.length - 1) {
            setCurrentOffset(currentOffset + 1);
          } else if (hasSwipedRight(touchDownPosition.current, pos) && currentOffset) {
            setCurrentOffset(currentOffset - 1);
          }
        }}
      >
        {Children.map(children, (child, idx) => {
          const isFocused = idx === currentOffset;
          const myOffset = currentOffset * 100;
          return (
            <div
              className={classnames({
                'sm-mrx-carousel__item': true,
                'sm-mrx-carousel__item--visible': isFocused,
              })}
              style={{ left: `-${myOffset}%` }}
            >
              {child}
            </div>
          );
        })}
      </div>
    </div>
  );
};

Carousel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Carousel;
